import React from 'react';
import { Link } from 'react-router-dom';
interface Step {
  id: string;
  title: string;
  description?: string;
}
interface OnboardingLayoutProps {
  currentStep: number;
  totalSteps: number;
  steps: Step[];
  title: string;
  description: string;
  children: React.ReactNode;
  onBack: () => void;
  onNext: () => void;
  onSkip?: () => void;
  isNextDisabled?: boolean;
  nextLabel?: string;
}
export function OnboardingLayout({
  currentStep,
  totalSteps,
  steps,
  title,
  description,
  children,
  onBack,
  onNext,
  onSkip,
  isNextDisabled = false,
  nextLabel = 'Next'
}: OnboardingLayoutProps) {
  return <div className="min-h-screen bg-gray-50 flex flex-col md:flex-row" data-id="element-621">
      {/* Left Sidebar - Progress */}
      <div className="w-full md:w-80 bg-white border-r border-gray-200 p-6 md:p-8 flex flex-col" data-id="element-622">
        <div className="mb-8" data-id="element-623">
          <Link to="/" className="flex items-center gap-2 text-indigo-600 font-bold text-xl mb-6" data-id="element-624">
            <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center text-white" data-id="element-625">
              S
            </div>
            Sponsrai
          </Link>
          <h2 className="text-xl font-bold text-gray-900" data-id="element-626">{title}</h2>
          <p className="text-sm text-gray-500 mt-1" data-id="element-627">{description}</p>
        </div>

        <div className="flex-1 overflow-y-auto" data-id="element-628">
          <div className="space-y-6 relative" data-id="element-629">
            {/* Vertical line connecting steps */}
            <div className="absolute left-3.5 top-2 bottom-2 w-0.5 bg-gray-100 -z-10" data-id="element-630" />

            {steps.map((step, index) => {
            const stepNumber = index + 1;
            const isActive = stepNumber === currentStep;
            const isCompleted = stepNumber < currentStep;
            return <div key={step.id} className="flex gap-4" data-id="element-631">
                  <div className={`
                    w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 transition-colors duration-300
                    ${isActive ? 'bg-indigo-600 text-white ring-4 ring-indigo-50' : ''}
                    ${isCompleted ? 'bg-green-500 text-white' : ''}
                    ${!isActive && !isCompleted ? 'bg-gray-200 text-gray-500' : ''}
                  `} data-id="element-632">
                    {isCompleted ? '✓' : stepNumber}
                  </div>
                  <div className={`pt-1 transition-opacity duration-300 ${isActive ? 'opacity-100' : 'opacity-60'}`} data-id="element-633">
                    <p className="text-sm font-medium text-gray-900" data-id="element-634">
                      {step.title}
                    </p>
                    {step.description && isActive && <p className="text-xs text-gray-500 mt-0.5" data-id="element-635">
                        {step.description}
                      </p>}
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col" data-id="element-636">
        <div className="flex-1 p-4 md:p-8 lg:p-12 max-w-3xl mx-auto w-full flex flex-col justify-center" data-id="element-637">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-10 min-h-[400px] flex flex-col" data-id="element-638">
            {children}
          </div>
        </div>

        {/* Footer Actions */}
        <div className="bg-white border-t border-gray-200 p-4 md:px-12 md:py-6" data-id="element-639">
          <div className="max-w-3xl mx-auto flex items-center justify-between" data-id="element-640">
            <button onClick={onBack} disabled={currentStep === 1} className={`text-sm font-medium px-4 py-2 rounded-lg transition-colors ${currentStep === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-641">
              Back
            </button>

            <div className="flex items-center gap-3" data-id="element-642">
              {onSkip && <button onClick={onSkip} className="text-sm font-medium text-gray-500 hover:text-gray-700 px-4 py-2" data-id="element-643">
                  Skip
                </button>}
              <button onClick={onNext} disabled={isNextDisabled} className={`
                  px-6 py-2.5 rounded-lg text-sm font-medium text-white transition-all shadow-sm
                  ${isNextDisabled ? 'bg-gray-300 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700 hover:shadow-md'}
                `} data-id="element-644">
                {nextLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}